import React from 'react';
import { styled } from '@teko/ui';

const ProgressBarWrapper = styled.div``;
const Bar = styled.div`
  height: 4px;
  background-color: #e0e0e0;
  width: 600px;
  position: relative;
  margin: 0 auto;
`;
const Progress = styled.div(({ width, variant }) => `
    position: absolute;
    height: 4px;
    left: 0;
    top: 0;
    background-image: ${variant === "danger" ? "linear-gradient(to right,#ff0024,#c31414)" : "linear-gradient(to right, #0064ff, #1435c3)"};
    width: ${width}%;
  `);
const Dot = styled.div(({ status, left, variant }) => `
    width: ${status === "active" ? "32px" : "16px"};
    height: ${status === "active" ? "32px" : "16px"};
    position: absolute;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background-color: ${status === "inactive" ? "#e0e0e0" : `${variant === "danger" ? "rgba(235, 33, 1, 0.25)" : "rgba(20, 53, 195, 0.25)"}`};

    left: ${left}%;
  `);
const DotCenter = styled.div(({ status, variant }) => `
    width: ${status === "active" ? "20px" : "10px"};
    height: ${status === "active" ? "20px" : "10px"};
    background-color: ${status === "inactive" ? "#9b9b9b" : `${variant === "danger" ? "#eb2101" : "#1435c3"}`};
    border-radius: 50%;
    box-shadow: ${status === "active" ? `${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1, 1)" : "0 0 0 0 rgb(20, 53, 195, 1)"}` : ""};
    transform: scale(1);
    animation: ${status === "active" ? "dot-pulse" : null};
    animation-duration: 2s;
    animation-iteration-count: infinite;

    @keyframes dot-pulse {
      0% {
        transform: scale(0.9);
        box-shadow: ${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1,  0.7)" : "0 0 0 0 rgba(20, 53, 195, 0.7)"};
      }

      70% {
        transform: scale(1);
        box-shadow: ${variant === "danger" ? "0 0 0 6px rgba(235, 33, 1,  0)" : "0 0 0 6px rgba(20, 53, 195, 0)"};
      }

      100% {
        transform: scale(0.9);
        box-shadow: ${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1,  0)" : "0 0 0 0 rgba(20, 53, 195, 0)"};
      }
    }
  `);
const ContentWrapper = styled.div(({ left }) => `
    position: absolute;
    top: 28px;
    transform: translateX(-50%);
    width: max-content;
    text-align: center;
    left: ${left}%;
  `);
const Status = styled.p(({ active }) => `
    font-size: 14px;
    color: #333;
    letter-spacing: -0.4px;
    margin-bottom: 4px;
    font-weight: ${active ? "700" : ""};
  `);
const FinishedDate = styled.p(({ active }) => `
    font-size: 12px;
    color: ${active ? "#333" : "#848788"};
    margin: 0;
  `);
const Stepper = ({
  steps,
  currentStep,
  variant
}) => {
  return /* @__PURE__ */ React.createElement(ProgressBarWrapper, null, /* @__PURE__ */ React.createElement(Bar, null, /* @__PURE__ */ React.createElement(Progress, {
    width: currentStep * 100 / (steps.length - 1),
    variant
  }), steps.map((step, index) => {
    const status = index > currentStep ? "inactive" : index === currentStep ? "active" : null;
    return /* @__PURE__ */ React.createElement(Dot, {
      status,
      left: index * (100 / (steps.length - 1)),
      key: index,
      variant
    }, /* @__PURE__ */ React.createElement(DotCenter, {
      status,
      variant
    }));
  }), steps.map(({ status, date }, index) => /* @__PURE__ */ React.createElement(ContentWrapper, {
    left: index * (100 / (steps.length - 1)),
    key: index
  }, /* @__PURE__ */ React.createElement(Status, {
    active: index === currentStep
  }, status), date && /* @__PURE__ */ React.createElement(FinishedDate, {
    active: index === currentStep
  }, date)))));
};

export { Stepper };
